module.exports = __webpack_public_path__ + "img/aj1.8a54ab31.jpeg";